import React from "react";
import "./index.css";
import "./styles.css";
import Router from "./components/Router";
import MessagingContextProvider from "./components/MessagingContext";
import AuthContextProvider from "./shared/contexts/AuthContext";
import { BASE_URL } from "./apiconstants";
import AsyncStorage from "./AsyncStorage";

export default function App() {
  return (
    <MessagingContextProvider>
      <AuthContextProvider
        baseURL={BASE_URL}
        storage={AsyncStorage}
        asyncStorage={true}
        routeOnLogout={() => {
          window.location.href = "/login";
        }}
      >
        <Router />
      </AuthContextProvider>
    </MessagingContextProvider>
  );
}
